import * as React from "react";
const SvgRedis = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <mask
      id="Redis_svg__a"
      width={16}
      height={14}
      x={0}
      y={1}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path fill="#fff" d="M15.333 1.715H.666v12.57h14.667z" />
    </mask>
    <g
      fill="#fff"
      fillRule="evenodd"
      clipRule="evenodd"
      mask="url(#Redis_svg__a)"
    >
      <path d="M11.978 11.157c1.206-.518 2.39-1.027 2.777-1.228v-.008c.382-.197.57-.353.573-.493h.003v1.463c0 .152-.176.3-.575.514-.379.199-1.527.693-2.709 1.201-1.256.541-2.55 1.098-3 1.334-.874.458-1.342.445-2.025.118-.33-.158-1.505-.647-2.72-1.154-1.297-.541-2.64-1.101-3.043-1.294-.393-.184-.593-.341-.593-.489v-1.46c.023.142.22.293.592.469.399.189 1.72.74 3.005 1.275 1.228.511 2.424 1.01 2.757 1.169.684.325 1.151.33 2.025-.12.442-.228 1.698-.767 2.933-1.298" />
      <path d="M11.955 8.746c1.214-.522 2.413-1.036 2.801-1.24v-.003c.378-.194.566-.35.574-.49v1.462c0 .152-.175.304-.574.515-.388.202-1.58.713-2.79 1.233-1.23.528-2.48 1.064-2.92 1.291-.873.45-1.337.446-2.02.118-.334-.16-1.533-.657-2.762-1.167-1.286-.533-2.607-1.08-3.005-1.27-.393-.187-.593-.343-.593-.492V7.225c.01.146.208.301.594.486.402.192 1.745.75 3.043 1.29 1.214.505 2.39.993 2.72 1.15.682.327 1.15.33 2.024-.12.439-.225 1.681-.759 2.908-1.285" />
      <path d="M1.23 4.278c-.399.156-.585.3-.562.455v1.464c0 .148.2.306.593.49.403.192 1.749.751 3.049 1.291 1.214.505 2.388.993 2.718 1.15.683.326 1.147.329 2.02-.12.438-.225 1.673-.755 2.896-1.28 1.218-.524 2.424-1.041 2.814-1.245.4-.21.575-.36.573-.514V4.506c.007-.149-.192-.28-.583-.424-.376-.137-1.557-.601-2.746-1.069-1.212-.475-2.432-.955-2.82-1.097-.771-.283-1.084-.273-1.991.054-.793.286-4.18 1.61-5.524 2.137zm7-1.383.968-.318-.262.627.984.369-1.269.132-.285.685-.46-.764-1.467-.132 1.096-.395-.33-.607zm.061 4L5.92 5.908l3.398-.521zM6.82 4.654c0-.386-.815-.702-1.816-.702-1.003 0-1.817.316-1.817.701 0 .386.817.702 1.817.702s1.816-.316 1.816-.702m6.615-.1-2.01-.795.002 1.589zm-2.012-.795.002 1.589-.218.085-2.01-.795z" />
    </g>
  </svg>
);
export default SvgRedis;
